export default __webpack_public_path__ + "static/media/logo.0faa5f09.svg";